<div [ngClass]="styles.section">
	<button class="btn btn-transparent" [ngClass]="styles.collapseBtn" (click)="layoutCollapsed = !layoutCollapsed" [attr.aria-label]="(layoutCollapsed ? 'UI_CollapsableSection_Expand' : 'UI_CollapsableSection_Collapse' ) | translate" [attr.aria-expanded]="!layoutCollapsed">
		{{'Layout' | translate}}
		<span class="glyphicons" [ngClass]="layoutCollapsed ? 'chevron-right' : 'chevron-down'"></span>
	</button>

	<div [collapse]="layoutCollapsed" [isAnimated]="true">

		<vb-ui-form-group>
			<div #uiLabel>{{ 'Event_Producer_Frames' | translate }}</div>

			<div [ngClass]="styles.layoutFilter" uiControl>
				<button type="button" *ngFor="let layoutFilterOpt of layoutFilterOpts" [ngClass]="layoutFilterOpt === layoutFilter ? 'active' : ''" (click)="toggleLayoutFilter(layoutFilterOpt)">
					@if(layoutFilterOpt === undefined) {
						{{ 'All' | translate }}
					}
					@else {
						{{layoutFilterOpt}}
						@if(layoutFilterOpt === maxLayoutFilter) {
							{{'+'}}
						}
					}
				</button>
			</div>
		</vb-ui-form-group>

		<vb-ui-toggle-content-display [totalItems]="filteredLayouts.length" [minItems]="6">

			<button type="button" *ngFor="let layout of filteredLayouts" #vbUiToggleItem [ngClass]="[styles.layoutBtn, layout === activeLayout ? styles.active : '']" (click)="setLayout(layout)" [attr.aria-label]="layout">
				<layout-icon [layoutType]="layout">
				</layout-icon>
			</button>
		</vb-ui-toggle-content-display>
	</div>
</div>

<div [ngClass]="styles.section">
	<button class="btn btn-transparent" [ngClass]="styles.collapseBtn" (click)="backgroundCollapsed = !backgroundCollapsed" [attr.aria-label]="(backgroundCollapsed ? 'UI_CollapsableSection_Expand' : 'UI_CollapsableSection_Collapse' ) | translate" [attr.aria-expanded]="!backgroundCollapsed">
		{{'Background' | translate}}
		<span class="glyphicons" [ngClass]="backgroundCollapsed ? 'chevron-right' : 'chevron-down'"></span>
	</button>

	<div [collapse]="backgroundCollapsed" [isAnimated]="true">
		<div [ngClass]="styles.buttonGrid">



			<div [ngClass]="styles.bgImageBtn" *ngFor="let background of defaultBackgrounds">
				<button type="button" [ngClass]="[styles.layoutBtn, background === activeBackground ? styles.active : '']" (click)="setBackground(background)" [style.background-image]="getBgImg(background)">
				</button>
				<button type="button" [ngClass]="styles.removeBtn" *ngIf="canDeleteBg(background)" (click)="removeDefaultBg(background)" [attr.aria-label]="'Remove' | translate">
					<span class="glyphicons remove_2"></span>
				</button>
			</div>

			<div [ngClass]="styles.bgImageBtn" *ngFor="let img of webcast.producerBgImages">
				<button type="button" [ngClass]="[styles.layoutBtn, img.id === activeBackground ? styles.active : '']" [style.background-image]="customBgImgUrl(img)" (click)="setCustomBackground(img)">
				</button>
				<button type="button" [ngClass]="styles.removeBtn" *ngIf="canDeleteBg(img.id)" (click)="removeBgImage(img)" [attr.aria-label]="'Remove' | translate">
					<span class="glyphicons remove_2"></span>
				</button>
			</div>

			<div [ngClass]="styles.bgImageBtn" *ngIf="canAddBgImg()">
				<div class="btn-file-wrapper" [ngClass]="styles.layoutBtn" fileUpload (onAdd)="addBgImage($event.file)">
					<span class="glyphicons plus"></span>
					{{ 'Event_Producer_AddBackground' | translate }}
					<input type="file" [accept]="imgExtensions" name="producerBgImageFile" multiple="multiple" [attr.aria-label]="'Event_Producer_AddBackground' | translate">
				</div>
				<div vbUiErrorMessage *ngIf="invalidFileType">
					{{ 'ImageSelector_FileExtensionError' | translate }}: {{imgExtensions}}
				</div>
			</div>
			<div [ngClass]="styles.bgImageBtn" *ngIf="videoBackground || activeBackground">
				<button type="button" [ngClass]="styles.layoutBtn" (click)="clearBackground()">
					<span class="glyphicons minus"></span>
					{{ 'Event_Producer_ClearBackground' | translate }}
				</button>
			</div>
		</div>

		<span [ngClass]="styles.helpTxt">
			{{'RecommendedImageSize1080p' | translate }}
		</span>
	</div>
</div>

<div [ngClass]="styles.section">
	<button class="btn btn-transparent" [ngClass]="styles.collapseBtn" (click)="bannersCollapsed = !bannersCollapsed" [attr.aria-label]="(bannersCollapsed ? 'UI_CollapsableSection_Expand' : 'UI_CollapsableSection_Collapse' ) | translate" [attr.aria-expanded]="!bannersCollapsed">
		{{'Banners' | translate}}
		<span class="glyphicons" [ngClass]="bannersCollapsed ? 'chevron-right' : 'chevron-down'"></span>
	</button>

	<div [collapse]="bannersCollapsed" [isAnimated]="true">

		<form (submit)="updateBannerOpts()">

			<vb-ui-form-group>
				<label for="producerShowBanner" #uiLabel>{{ 'Event_Producer_ShowBanners_Label' | translate }}</label>

				<vb-ui-select uiControl>
					<select #selectElement id="producerShowBanner" name="producerShowBanner" [(ngModel)]="bannerOpts.timing" (ngModelChange)="updateBannerOpts()">
						<option [ngValue]="BannerTiming.Default">{{ 'Event_Producer_ShowBanners_Hide' | translate }}</option>
						<option [ngValue]="BannerTiming.Always">{{ 'Event_Producer_ShowBanners_Show' | translate }}</option>
						<option [ngValue]="BannerTiming.Auto10s">{{ 'Event_Producer_ShowBanners_Show10Seconds' | translate }}</option>
					</select>
				</vb-ui-select>
			</vb-ui-form-group>

			<vb-ui-form-group>
				<label #uiLabel>{{ 'Branding_Theme' | translate }}</label>

				<div layout="row" uiControl flex-align="center">
					<button type="button" (click)="setBannerTheme(BannerTheme.Default)" [ngClass]="[styles.layoutBtn, !bannerOpts.theme ? styles.active : '']">
						<video-banner [name]="'Default' | translate" [theme]="BannerTheme.Default">
						</video-banner>
					</button>

					<button type="button" (click)="setBannerTheme(BannerTheme.Bubble)" [ngClass]="[styles.layoutBtn, bannerOpts.theme === BannerTheme.Bubble ? styles.active : '']">
						<video-banner [name]="'Event_Producer_BannerTheme_Bubble' | translate" [theme]="BannerTheme.Bubble"></video-banner>
					</button>
				</div>
			</vb-ui-form-group>

			<vb-ui-form-group>
				<label for="producerBannerAccent" #uiLabel>{{ 'Branding_AccentColor' | translate }}</label>

				<vb-ui-color-selector uiControl id="producerBannerAccent" name="producerBannerAccent" [(ngModel)]="bannerOpts.accentColor" (ngModelChange)="onBannerAccentChange()" [defaultColor]="ThemeService.accentColor" [accessibilityLabel]="'Branding_AccentColor' | translate">
				</vb-ui-color-selector>
			</vb-ui-form-group>
		</form>
	</div>
</div>
